exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-avatar[data-v-92dadd00]{display:flex;justify-self:center;align-items:center}.container-avatar .container-text[data-v-92dadd00]{margin-left:16px;align-self:center;width:100%;display:flex;flex-flow:wrap}.container-avatar .container-text .container-data[data-v-92dadd00]{display:flex;padding:0}.container-avatar .container-text .container-data .text-title[data-v-92dadd00]{margin:0;padding:0;color:#4b4b4b;font-size:18px;font-weight:800}.container-avatar .container-text .container-data .text-content[data-v-92dadd00]{margin:0;margin-left:5px;padding:0;color:#4b4b4b;font-size:20px;width:fit-content;text-transform:capitalize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-92dadd00","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/Terapias/TarjetaPaciente/TarjetaPaciente.scss
// module id = 1161
// module chunks = 0